import Pool from "../../UserPool";

export default function NoAccess({ setAuth, setUserOrg }) {

  const logoutUser = () => {
    const user = Pool.getCurrentUser();

    if (user) {
      user.signOut()
    };
    setUserOrg(null);
    localStorage.removeItem("token");
    setAuth(false);
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen font-sans text-ktx-purple gap-2">
      <button className="fixed top-[5dvh] right-[5dvw] flex hover:text-ktx-navy font-medium text-[24px] items-center gap-1" onClick={() => logoutUser()}>
        <svg className="w-6 h-6 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 12H8m12 0-4 4m4-4-4-4M9 4H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h2" />
        </svg>
        Logout
      </button>
      <h1 className="text-[36px]">Access Restricted</h1>
      <h3 className="text-[24px] text-center max-w-[600px] mb-4">
        Your organization currently does not have permission to access this dashboard. Please contact our support team for assistance.
      </h3>
    </div>
  );
}
